import React, { useEffect, useState } from 'react'
import './profile.scss'
import { useLocation } from "react-router-dom";
import Newsletter from './Newsletter'


const NewsletterContainer = ({ iframeId, appHeightChanged }) => {
    const location = useLocation();

    const newsGroups = location?.state?.newsgroup
  
   

   
    const [chosed, setChosed] = useState([])
    const [clickedNewsgroup, setClickedNewsgroup] = useState()
    const [updatedNewsgroup, setUpdatedNewsgroup] = useState()

 

    if (window.parent != window) {
        appHeightChanged(iframeId, true)
    }

    function handleArrow(e, item) {
       
            appHeightChanged(iframeId, true)
      
        if (chosed.includes(item.Name) === true) {
            let newarr = chosed.filter((i) => i !== item.Name)
            setChosed(newarr)
        }
        else {
            let added = [...chosed, item.Name]
           
            setChosed(added)
        }
        setClickedNewsgroup(item)
      
      
    }
   

    if (clickedNewsgroup) { 
    const index = clickedNewsgroup.Newsgroups.findIndex(obj => obj.No === updatedNewsgroup?.No)
      
        if (index !== -1) {
           clickedNewsgroup.Newsgroups.splice(index, 1, updatedNewsgroup);
        }
    }
  
   
    return (
        <main className='newsletter-container'>

            <p className='profile-title'>Nyhedsbreve</p>
            <p className='profile-text'>Administrér nyhedsbreve</p>
         
         
            <section style={{paddingBottom:'50px'} }>

                
                {newsGroups?.map((item,index) => (
                    <>
                        <div className='newsletter' key={item.Name} onClick={(e) => handleArrow(e,item)} id={item} style={{ cursor: 'pointer' }}  >
                            <p className='name'>{item.Name}</p>
                            <p className='letter-nr'>{item.Newsgroups.length} {item.Newsgroups.length > 1 ? 'nyhedsbreve' : 'nyhedsbrev' }</p>
                            <div >
                                {chosed.includes(item.Name) ?
                                    <svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 9.5L9.5 1L1 9.5" stroke="white" />
                                    </svg>
                       

                                    : <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 1L9.5 9.5L1 0.999999" stroke="white" />
                                    </svg>
                                }
                        </div>
                        </div>
                        { chosed.includes(item.Name) ?
                            <div className='newsletter-underdiv'>
                                <p className='title'>Du er tilmeldt disse nyhedsbreve fra biografen:</p>
                                <div className='types'>
                                 {item.Newsgroups.map((newsletter) => (

                                     <Newsletter newsletter={newsletter} orgNo={item.No} setUpdatedNewsgroup={setUpdatedNewsgroup} />
                                ))}
                                </div>
                                
                                  
                                
                            </div>
                             : null
                         }
                     </>
                   
                    )) }
                   
                     
               
              
            </section>
        </main>
    )
}

export default NewsletterContainer